import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import { Container, Row, Col, Button, Form, Input } from "reactstrap";
import Swiper from "react-id-swiper";
import { BsDownload } from "react-icons/bs";
import LevelSelector from "../ClapprPlayer/level-selector";
import ClapprPlayer from "../ClapprPlayer/ClapprPlayer";
import Play360Video from "../ClapprPlayer/Play360Video";
import { config } from "../../constants/domainConfig";
import * as vars from "../../constants/constants";
import { messages } from "../../constants/messages";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getVideoOrChannelRelatedData } from "../../actions/PlayActions";
import {
  addFavoriteVideo,
  addLikesVideos,
} from "../../actions/FavoriteActions";
import { showMessage } from "../../actions/FlashMessageActions";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { addVideoHistory } from "../../actions/HistoryActions";
import {
  console_log,
  parseQueryString,
  bidiotvMoviesListByLang,
} from "../../utils/helper";
import { movies } from "../../constants/movies";
import { hollywoodMovies } from "../../constants/hollywoodmovies";
import { FormattedMessage } from "react-intl";

// const msg = messages[config.lang];

let playUrl = "";

const MOBIOFIT_VIDEO_CDN = "https://video.mobiofit.com/";
const isProtectedMobiofitVideo = (videoUrl) =>
  typeof videoUrl === "string" && videoUrl.indexOf(MOBIOFIT_VIDEO_CDN) === 0;

class PlayVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRTL: false,
      data: {},
      isPlaying: false,
      playUrl: "",
      selectedVideo: {},
    };

    this.getVideoCategories = this.getVideoCategories.bind(this);
    this.addRemoveFavorite = this.addRemoveFavorite.bind(this);
    this.isVideoFavorite = this.isVideoFavorite.bind(this);
    this.playVideo = this.playVideo.bind(this);
    this.getVideo = this.getVideo.bind(this);
    this.goToPlay = this.goToPlay.bind(this);
    this.addHistoryVideo = this.addHistoryVideo.bind(this);
    this.addLike = this.addLike.bind(this);
    this.isVideoLiked = this.isVideoLiked.bind(this);
    this.selectedVideo = this.selectedVideo.bind(this);
    this.getSignedMobiofitVideo = this.getSignedMobiofitVideo.bind(this);
  }
  selectedVideo(videoId) {
    let result, selectedVideo, play;
    if (window.location.href.indexOf("/movies") >= 0) {
      play = hollywoodMovies;
    } else {
      play = bidiotvMoviesListByLang;
    }
    let foundCategory = play.find((cat) => {
      let videoIds = cat.videos.map((v) => v.id);
      if (~videoIds.indexOf(videoId)) return cat;
    });
    if (foundCategory) {
      return foundCategory.videos.find((v) => v.id == videoId);
    }
    return null;
  }

  componentWillMount() {
    // let play = sessionStorage.getItem("mobiotv") ? JSON.parse(sessionStorage.getItem("mobiotv")).PlayReducer : null
    // if (play.data.video) {
    //     this.props.setHeaderTitle(play.data.video.name);
    //     this.getVideoCategories(play.data.video.id);
    // }

    let selectedVideo = this.selectedVideo(
      parseInt(parseQueryString(this.props.location.search)["vid"]),
    );
    this.setState({ selectedVideo: selectedVideo });
    // let play=sessionStorage.getItem("mobiotv")? JSON.parse(sessionStorage.getItem("mobiotv")).PlayReducer:null
    if (selectedVideo) {
      this.props.setHeaderTitle(selectedVideo.name);
      this.getVideoCategories(selectedVideo.id);
    }
    window.addEventListener("resize", () => this.toggleVideoDescription());
    window.addEventListener("resize", () => this.testBG());
  }

  shouldComponentUpdate() {
    return true;
  }

  componentDidUpdate() {
    this.toggleVideoDescription();
    this.testBG();
  }

  componentDidMount() {
    let selectedVideo = this.state.selectedVideo;
    document.body.classList.add("play-page");
    window.scrollTo(0, 0);
    // let play=sessionStorage.getItem("mobiotv")? JSON.parse(sessionStorage.getItem("mobiotv")).PlayReducer:null
    // this.getVideo(play.data.video.id);
    this.getVideo(selectedVideo.id);
    this.toggleVideoDescription();
    this.testBG();
  }

  toggleVideoDescription() {
    let videoDescButtonWrap = document.querySelector(".video__desc__btn-wrap");
    let videoDesc = document.querySelector(".video__desc");
    let videoDetailsWrap = document.querySelector(".video__details__wrap");
    let videoDescButton = document.querySelector(".video__desc__btn");
    let relatedSlide = document.querySelector(".related-slide");
    if (window.innerWidth <= 575) {
      if (videoDesc.scrollHeight > 75) {
        videoDescButtonWrap.style.opacity = "1";
        videoDescButtonWrap.style.height = "auto";
        videoDescButtonWrap.style.width = "100%";
      } else {
        videoDescButtonWrap.style.opacity = "0";
        videoDescButtonWrap.style.height = "0";
        videoDescButtonWrap.style.width = "0";
      }
    } else {
      videoDescButtonWrap.style.opacity = "0";
      videoDescButtonWrap.style.height = "0";
      videoDescButtonWrap.style.width = "0";
    }
    if (videoDetailsWrap) {
      videoDetailsWrap.addEventListener("click", function (e) {
        if (e.target.className === "video__desc__btn") {
          videoDesc.classList.toggle("video__desc--more");
          if (videoDesc.classList.contains("video__desc--more")) {
            videoDesc.style.maxHeight = videoDesc.scrollHeight + "px";
            videoDescButton.textContent = "Show Less";
          } else {
            videoDesc.style.maxHeight = "";
            videoDescButton.textContent = "Show More";
          }
        }
      });
    }
    if (relatedSlide) {
      relatedSlide.addEventListener("click", function (e) {
        if (e.target.className !== "heart-fill") {
          if (videoDesc.classList.contains("video__desc--more")) {
            videoDesc.classList.toggle("video__desc--more");
            videoDesc.style.maxHeight = "";
            videoDescButton.textContent = "Show More";
          }
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    // if (this.props.play.data.video.id != nextProps.play.data.video.id) {
    //     window.scrollTo(0, 0);
    //     this.getVideo(nextProps.play.data.video.id);
    //     this.props.setHeaderTitle(nextProps.play.data.video.name);
    //     this.getVideoCategories(nextProps.play.data.video.id);
    // }
    this.toggleVideoDescription();
  }

  componentWillUnmount() {
    document.body.classList.remove("play-page");
    window.removeEventListener("resize", () => this.toggleVideoDescription());
    window.removeEventListener("resize", () => this.testBG());
  }

  getVideoCategories(videoId) {
    let category = sessionStorage.getItem("mobiotv")
      ? JSON.parse(sessionStorage.getItem("mobiotv")).CategoryReducer
      : null;
    let mixContent = bidiotvMoviesListByLang.concat(category.videos);
    if (config.title == "bidiotv") {
      let page = this.props.history.location.pathname.split("/")[3];
      let videoCategory;
      if (page === "movies") {
        videoCategory = hollywoodMovies.find((category) => {
          let videoIds = category.videos.map((v) => v.id);
          if (~videoIds.indexOf(videoId)) {
            return category;
          }
        });
      } else {
        videoCategory = bidiotvMoviesListByLang.find((category) => {
          let videoIds = category.videos.map((v) => v.id);
          if (~videoIds.indexOf(videoId)) {
            return category;
          }
        });
      }

      let video = videoCategory.videos.find((v) => v.id == videoId);
      this.setState({
        data: Object.assign({ video: video }, { category: videoCategory }),
      });
    } else if (config.title == "watch") {
      let videoCategory = mixContent.find((category) => {
        let videoIds = category.videos.map((v) => v.id);
        if (~videoIds.indexOf(videoId)) {
          return category;
        }
      });
      let video = videoCategory.videos.find((v) => v.id == videoId);
      this.setState({
        data: Object.assign({ video: video }, { category: videoCategory }),
      });
    } else {
      let videoCategory = this.props.category.videos.find((category) => {
        let videoIds = category.videos.map((v) => v.id);
        if (~videoIds.indexOf(videoId)) {
          return category;
        }
      });
      let video = videoCategory.videos.find((v) => v.id == videoId);
      this.setState({
        data: Object.assign({ video: video }, { category: videoCategory }),
      });
    }
  }

  isVideoFavorite(videoId) {
    let indexOf = this.props.favorite.videos.findIndex((f) => {
      return f.videoId == videoId;
    });

    if (indexOf != -1) {
      return true;
    }
    return false;
  }

  addRemoveFavorite(video, event) {
    event.preventDefault();
    if (
      event.target.tagName == "path" ||
      event.target.classList.contains("favoriteClick")
    ) {
      this.videoFavorite(video);
    }
  }

  videoFavorite(video) {
    let favoriteVideos = this.props.favorite.videos;
    let indexOf = favoriteVideos.findIndex((f) => {
      return f.videoId == video.id;
    });
    let videoToBeUpdated = {
      videoId: video.id,
      duration: video.duration,
      name: video.name,
      preview: video.preview,
    };

    if (indexOf == -1) {
      this.props.showMessage({
        message: messages[config.lang].addToFavorites,
        type: true,
      });
      favoriteVideos.push(videoToBeUpdated);
      axios
        .post(vars.BASE_API_URL + "/favorites/videos", videoToBeUpdated)
        .then((response) => {
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    } else {
      this.props.showMessage({
        message: messages[config.lang].removeFromFavorites,
        type: false,
      });
      favoriteVideos.splice(indexOf, 1);
      axios
        .delete(
          vars.BASE_API_URL + "/favorites/videos/" + videoToBeUpdated.videoId,
        )
        .then((response) => {
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    }

    this.props.addFavoriteVideo(favoriteVideos);
  }

  playVideo() {
    let currentThis = this;
    setTimeout(() => {
      currentThis.setState({
        isPlaying: !this.state.isPlaying,
      });
      this.addHistoryVideo(this.state.data.video);
    }, 1000);
  }

  getVideo(videoId) {
    let url = window.location.origin;
    this.props.show();
    if (config.title !== "bidiotv") {
      axios
        .get(vars.BASE_API_URL + "/getVideoStreamingURL/" + videoId + "/WIFI")
        .then((response) => {
          // this.setState({
          playUrl = response.data.data.stream.url;
          // });
          this.props.hide();
        })
        .catch((error) => {
          this.props.hide();
          console_log(error);
        });
      let videourl = this.state.data.video.videoUrl;
      if (videourl != undefined) {
        if (videourl.indexOf("bidiotv") >= 0) {
          playUrl = "https://cdn.mobiotv.com/" + this.state.data.video.filename;
        }
      }
    }
    // else if (url.indexOf('uk') >=0){
    //     playUrl="https://cdn.mobiotv.com/" + this.state.data.video.filename
    // }
    else if (isProtectedMobiofitVideo(this.state.data.video.videoUrl)) {
      this.getSignedMobiofitVideo(this.state.data.video.videoUrl);
      return;
    }
    else {
      playUrl = this.state.data.video.videoUrl;
    }
    this.props.hide();
  }
  // Protected MobioFit HLS videos need a CloudFront signature from the API before they can play.
  getSignedMobiofitVideo(videoUrl) {
    playUrl = "";
    axios
      .post(vars.BASE_API_URL + "/video/sign", { url: videoUrl })
      .then((response) => {
        playUrl =
          "/video-manifest/" +
          videoUrl.slice(MOBIOFIT_VIDEO_CDN.length) +
          "?" +
          response.data.data.query;
        this.setState({ playUrl: playUrl });
        this.props.hide();
      })
      .catch((error) => {
        this.props.hide();
        console_log(error);
      });
  }
  disPoseVideo() {
    this.setState({ isPlaying: !this.state.isPlaying });
  }
  goToPlay(data, event) {
    event.preventDefault();
    window.scrollTo(0, 0);
    this.setState(
      {
        data: Object.assign(
          { video: data.video },
          { category: this.state.data.category },
        ),
      },
      () => {
        this.getVideo(data.video.id);
        this.props.setHeaderTitle(data.video.name);
        this.getVideoCategories(data.video.id);
      },
    );

    if (
      event.target.tagName == "path" ||
      event.target.classList.contains("favoriteClick")
    ) {
      this.videoFavorite(data.video);
    } else {
      this.props.getVideoOrChannelRelatedData(data);
    }
    this.disPoseVideo();
  }

  addHistoryVideo(video) {
    let historyVideos = this.props.historyVideos.videos;
    let indexOf = historyVideos.findIndex((f) => {
      return f.videoId == video.id;
    });
    let videoToBeUpdated = {
      videoId: video.id,
      duration: video.duration,
      name: video.name,
      preview: video.preview,
    };

    if (indexOf == -1) {
      historyVideos.push(videoToBeUpdated);
      axios
        .post(vars.BASE_API_URL + "/history/videos", videoToBeUpdated)
        .then((response) => {
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    }

    this.props.addVideoHistory(historyVideos);
  }

  addLike(video, event) {
    event.preventDefault();
    this.videoLike(video);
  }

  videoLike(video) {
    let likedVideos = this.props.favorite.videosLiked;
    let indexOf = likedVideos.findIndex((f) => {
      return f.videoId == video.id;
    });

    let videoToBeUpdated = {
      videoId: video.id,
      duration: video.duration,
      name: video.name,
      preview: video.preview,
    };

    if (indexOf == -1) {
      likedVideos.push(videoToBeUpdated);
      axios
        .post(vars.BASE_API_URL + "/likes/videos", videoToBeUpdated)
        .then((response) => {
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    } else {
      likedVideos.splice(indexOf, 1);
      axios
        .delete(vars.BASE_API_URL + "/likes/videos/" + videoToBeUpdated.videoId)
        .then((response) => {
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    }

    this.props.addLikesVideos(likedVideos);
  }

  isVideoLiked(videoId) {
    let indexOf = this.props.favorite.videosLiked.findIndex((f) => {
      return f.videoId == videoId;
    });

    if (indexOf != -1) {
      return true;
    }
    return false;
  }

  testBG() {
    let testBG = document.querySelector(".test-bg");
    let playBG = document.querySelector(".play-bg");
    testBG.style.height = playBG.offsetHeight - 55 + "px";
  }

  render() {
    let page = this.props.history.location.pathname.split("/")[3];
    const sliderData = {
        slidesPerView: "auto",
        speed: 400,
        spaceBetween: page === "movies" ? 10 : 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          767: {
            direction: "vertical",
            slidesPerView: "auto",
            speed: 400,
            spaceBetween: 0,
            touchReleaseOnEdges: true,
          },
        },
      },
      heartIcon =
        '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
      heartIconNoBg =
        '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
      thumbsUpIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 456.814 456.814"><g class="thumbs-fill"><path d="M441.11 252.677c10.468-11.99 15.704-26.169 15.704-42.54 0-14.846-5.432-27.692-16.259-38.547-10.849-10.854-23.695-16.278-38.541-16.278h-79.082c.76-2.664 1.522-4.948 2.282-6.851.753-1.903 1.811-3.999 3.138-6.283 1.328-2.285 2.283-3.999 2.852-5.139 3.425-6.468 6.047-11.801 7.857-15.985 1.807-4.192 3.606-9.9 5.42-17.133 1.811-7.229 2.711-14.465 2.711-21.698 0-4.566-.055-8.281-.145-11.134-.089-2.855-.574-7.139-1.423-12.85-.862-5.708-2.006-10.467-3.43-14.272-1.43-3.806-3.716-8.092-6.851-12.847-3.142-4.764-6.947-8.613-11.424-11.565-4.476-2.95-10.184-5.424-17.131-7.421-6.954-1.999-14.801-2.998-23.562-2.998-4.948 0-9.227 1.809-12.847 5.426-3.806 3.806-7.047 8.564-9.709 14.272-2.666 5.711-4.523 10.66-5.571 14.849-1.047 4.187-2.238 9.994-3.565 17.415-1.719 7.998-2.998 13.752-3.86 17.273-.855 3.521-2.525 8.136-4.997 13.845-2.477 5.713-5.424 10.278-8.851 13.706-6.28 6.28-15.891 17.701-28.837 34.259-9.329 12.18-18.94 23.695-28.837 34.545-9.899 10.852-17.131 16.466-21.698 16.847-4.755.38-8.848 2.331-12.275 5.854-3.427 3.521-5.14 7.662-5.14 12.419v183.01c0 4.949 1.807 9.182 5.424 12.703 3.615 3.525 7.898 5.38 12.847 5.571 6.661.191 21.698 4.374 45.111 12.566 14.654 4.941 26.12 8.706 34.4 11.272 8.278 2.566 19.849 5.328 34.684 8.282 14.849 2.949 28.551 4.428 41.11 4.428h36.831c25.321-.38 44.061-7.806 56.247-22.268 11.036-13.135 15.697-30.361 13.99-51.679 7.422-7.042 12.565-15.984 15.416-26.836 3.231-11.604 3.231-22.74 0-33.397 8.754-11.611 12.847-24.649 12.272-39.115.024-6.097-1.4-13.328-4.261-21.706zM100.5 191.864H18.276c-4.952 0-9.235 1.809-12.851 5.426C1.809 200.905 0 205.188 0 210.137v182.732c0 4.942 1.809 9.227 5.426 12.847 3.619 3.611 7.902 5.421 12.851 5.421H100.5c4.948 0 9.229-1.81 12.847-5.421 3.616-3.62 5.424-7.904 5.424-12.847V210.137c0-4.949-1.809-9.231-5.424-12.847-3.617-3.618-7.898-5.426-12.847-5.426zM67.665 369.308c-3.616 3.521-7.898 5.281-12.847 5.281-5.14 0-9.471-1.76-12.99-5.281-3.521-3.521-5.281-7.85-5.281-12.99 0-4.948 1.759-9.232 5.281-12.847 3.52-3.617 7.85-5.428 12.99-5.428 4.949 0 9.231 1.811 12.847 5.428 3.617 3.614 5.426 7.898 5.426 12.847 0 5.14-1.805 9.468-5.426 12.99z"/></g></svg>',
      smartTvIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 72.6 72.6"><circle class="smart-tv-circle" cx="36.3" cy="36.3" r="34.3"/><path class="smart-tv-path" d="M48.9 29H31.2c-1.1 0-2-.9-2-2v-.8c0-1.1.9-2 2-2h17.7c1.1 0 2 .9 2 2v.8c0 1.1-.9 2-2 2zM49.1 38.9H31.4c-1.1 0-2-.9-2-2V36c0-1.1.9-2 2-2h17.7c1.1 0 2 .9 2 2v.8c0 1.2-.9 2.1-2 2.1zM48.9 48.9H31.2c-1.1 0-2-.9-2-2V46c0-1.1.9-2 2-2h17.7c1.1 0 2 .9 2 2v.8c0 1.2-.9 2.1-2 2.1zM26.4 25.9l-4.1-2.7c-.4-.2-.9 0-.9.5V29c0 .4.5.7.9.5l4.1-2.7c.3-.1.3-.6 0-.9zM26.4 36.5l-4.1-2.7c-.4-.2-.9 0-.9.5v5.3c0 .4.5.7.9.5l4.1-2.7c.3-.2.3-.7 0-.9zM26.4 45.7L22.3 43c-.4-.2-.9 0-.9.5v5.3c0 .4.5.7.9.5l4.1-2.7c.3-.2.3-.7 0-.9z"/></svg>';
    let comingSoon = {
      en: "Segera akan datang",
      be: "Binnenkort",
      it: "Prossimamente",
      id: "Prossimamente",
    };
    let playBtnText = {
      en: "Play",
      be: "Spelen",
      it: "RIPRODUCI",
      id: "PUTAR",
    };
    let watchNowText = {
      en: "Watch Now",
      be: "Nu Kijken",
      it: "Guarda ora",
      id: "menonton sekarang",
    };
    let video = this.state.data;
    const relatedOuterWrapperClass =
      config.subDomain == "iq" || config.subDomain == "ae.mobioviewtv"
        ? "related-outer-wrapper ar"
        : "related-outer-wrapper";
    return (
      <section className="play py-0">
        <div className="test-bg"></div>
        <Row>
          <Col xs="12">
            {video ? (
              <div
                className={
                  (this.state.isRTL ? "play-bg ar" : "play-bg") +
                  (this.state.isPlaying ? " video-active" : "")
                }
              >
                <div className="video">
                  {this.state.isPlaying && playUrl != "" ? (
                    video.video.duration === "Watch 3D" ? (
                      <Play360Video
                        source={playUrl}
                        data={{
                          rid: this.props.access.uid,
                          vname: video.video.name,
                          vcategory: video.category.name[config.lang],
                        }}
                      />
                    ) : (
                      <ClapprPlayer
                        source={playUrl}
                        poster={video.video.preview}
                        data={{
                          rid: this.props.access.uid,
                          vname: video.video.name,
                          vcategory: video.category.name[config.lang],
                        }}
                      />
                    )
                  ) : (
                    <div>
                      <div className="play__thumb-wrap">
                        <img
                          className={
                            page === "movies"
                              ? "play__thumb play__thumb--show"
                              : "play__thumb"
                          }
                          src={video.video.preview}
                          alt={video.video.name}
                        />
                      </div>
                      <div className="play__btn-wrap">
                        <a
                          className={
                            video.video.videoUrl === ""
                              ? "common-btn common-btn--red play__btn play__btn--disabled"
                              : "common-btn common-btn--red play__btn"
                          }
                          href="javascript:void(0);"
                          onClick={
                            video.video.videoUrl !== "" && this.playVideo
                          }
                        >
                          <span className="play__btn-inner">
                            {page === "movies" ? (
                              ""
                            ) : (
                              <i
                                className="fa fa-play"
                                aria-hidden="true"
                                style={
                                  config.lang === "ar"
                                    ? { marginLeft: "10px" }
                                    : {}
                                }
                              ></i>
                            )}
                            <span className="play__btn-text">
                              {video.video.videoUrl === "" ? (
                                <FormattedMessage
                                  id="comingSoon"
                                  defaultMessage="Coming Soon"
                                />
                              ) : (
                                <FormattedMessage
                                  id="play"
                                  defaultMessage="Play"
                                />
                              )}
                            </span>
                          </span>
                        </a>
                      </div>
                    </div>
                  )}
                  <div className="video__details__wrap">
                    <div className="video__details">
                      <div className="video__head">
                        <h3 className="video__title">
                          <FormattedMessage
                            id={video.video.name}
                            defaultMessage={video.video.name}
                          />
                        </h3>
                        <div className="video__head__ratings">
                          <div
                            className="video__fav favoriteClick"
                            onClick={this.addRemoveFavorite.bind(
                              this,
                              video.video,
                            )}
                          >
                            <input
                              className="icon-toggle favoriteClick"
                              id="two"
                              type="checkbox"
                              checked={this.isVideoFavorite(video.video.id)}
                              onChange={() => {}}
                            />
                            <label
                              className="icon-toggle-label favoriteClick"
                              htmlFor="two"
                            >
                              <span className="no-bg favoriteClick">
                                <i
                                  className="fa fa-star favoriteClick"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </label>
                            <span className="video__star__text">
                              <FormattedMessage
                                id="watchLater"
                                defaultMessage="Watch Later"
                              />
                            </span>
                          </div>
                          <div
                            className="video__rate"
                            onClick={this.addLike.bind(this, video.video)}
                          >
                            <input
                              className="icon-toggle"
                              id="three"
                              type="checkbox"
                              checked={this.isVideoLiked(video.video.id)}
                              onChange={() => {}}
                            />
                            <label
                              className="icon-toggle-label"
                              htmlFor="three"
                            >
                              <span
                                className="no-bg"
                                dangerouslySetInnerHTML={{
                                  __html: thumbsUpIcon,
                                }}
                              />
                            </label>
                            <span className="video__star__text">
                              <FormattedMessage
                                id="rate"
                                defaultMessage="Rate"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="video__sub-head">
                        <div className="imdb">
                          {/*<img className="imdb__image" src="./img/imdb.png" alt="IMDB" />*/}
                          {/*<span className="imdb__rating">{((Math.random() * 10) + 1).toFixed(1)} / 10</span>*/}
                        </div>
                        {page === "movies" ? null : (
                          <div className="video__extras">
                            {/* <ul className="list-unstyled video__extras__list">
                                                        <li className="video__extras__item"><span className="video__extras__text">PG-13</span></li>
                                                        <li className="video__extras__item"><span className="video__extras__text">2h 6min</span></li>
                                                        <li className="video__extras__item"><span className="video__extras__text">15 August 2014 (USA)&#x200E;</span></li>
                                                    </ul> */}
                            <div className="video__genre">
                              <img
                                src="./img/tag-icon.png"
                                alt="genre"
                                style={
                                  config.lang == "ar"
                                    ? { marginLeft: "10px" }
                                    : {}
                                }
                              />
                              <span
                                className="video__genre__text"
                                style={
                                  config.lang == "ar"
                                    ? { marginLeft: "15px" }
                                    : {}
                                }
                              >
                                {video.category
                                  ? video.category.name[config.lang]
                                  : ""}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                      <p
                        className={
                          this.state.isRTL
                            ? "video__desc text-reverse"
                            : "video__desc"
                        }
                      >
                        <FormattedMessage
                          id={
                            video.video.desc
                              ? video.video.desc
                              : video.video.name
                          }
                          defaultMessage={
                            video.video.desc
                              ? video.video.desc
                              : video.video.name
                          }
                        />
                      </p>
                      <div className="video__desc__btn-wrap">
                        <button className="video__desc__btn">
                          <FormattedMessage
                            id="showMore"
                            defaultMessage="Show More"
                          />
                        </button>
                      </div>
                      {config.subDomain === "ee" ||
                      config.subDomain === "fr" ? (
                        <a
                          href={playUrl.replace("/bidiotv/", "/eetv/")}
                          download
                          className="video__download__button"
                        >
                          Download <BsDownload size={18} />{" "}
                        </a>
                      ) : (
                        <ul className="list-unstyled video__cast">
                          <li className="video__cast__item">
                            <span className="video__cast__title">
                              <FormattedMessage
                                id="director"
                                defaultMessage="Director"
                              />
                              :{" "}
                            </span>
                            <span className="video__cast__text">NA</span>
                          </li>
                          <li className="video__cast__item">
                            <span className="video__cast__title">
                              <FormattedMessage
                                id="writers"
                                defaultMessage="Writers"
                              />
                              :{" "}
                            </span>
                            <span className="video__cast__text">NA</span>
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <div className={relatedOuterWrapperClass}>
          <Container fluid>
            <Row>
              <Col xs="12">
                {video.category ? (
                  <div className="related-wrap">
                    <div className="category-head related-top-links">
                      <h3
                        className={
                          config.useMobiofitTheme
                            ? "primary-text primary-text-mobiofit"
                            : "primary-text"
                        }
                      >
                        <FormattedMessage
                          id="relatedVids"
                          defaultMessage="Related Videos"
                        />
                      </h3>
                      <div className="category-head__favorite">
                        <h3>
                          <FormattedMessage
                            id="autoplay"
                            defaultMessage="Autoplay"
                          />
                        </h3>
                        <label
                          className="switch"
                          style={
                            config.lang === "ar" ? { marginRight: "10px" } : {}
                          }
                        >
                          <input type="checkbox" className="switch__checkbox" />
                          <span className="switch__slider round"></span>
                        </label>
                      </div>
                    </div>
                    <div>
                      {video.category.videos.length > 0 ? (
                        <Swiper
                          {...sliderData}
                          rebuildOnUpdate={false}
                          shouldSwiperUpdate={true}
                        >
                          {video.category.videos.map((v) => {
                            if (v.id != video.video.id) {
                              return page === "movies" ? (
                                <div
                                  key={v.id}
                                  className="related-slide portrait__slide portrait__slide--mobile hover__data movies-thumb"
                                  onClick={this.goToPlay.bind(this, {
                                    video: v,
                                  })}
                                >
                                  <div className="portrait__image portrait__image--mobile">
                                    <img src={v.preview} alt={v.name} />
                                  </div>
                                  <div className="portrait__details portrait__details--mobile">
                                    <div className="channels-thumb__fav">
                                      <input
                                        className="icon-toggle favoriteClick"
                                        id={"vod-" + v.id}
                                        type="checkbox"
                                        checked={this.isVideoFavorite(v.id)}
                                        onChange={() => {}}
                                      />
                                      <label
                                        className="icon-toggle-label favoriteClick"
                                        htmlFor={"vod-" + v.id}
                                      >
                                        <span className="favoriteClick">
                                          <i
                                            className="fa fa-star favoriteClick"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      </label>
                                    </div>
                                    <div className="hover__details">
                                      <div className="hover__container">
                                        <div className="hover__title-wrap">
                                          <h3 className="hover__title">
                                            {v.name}
                                          </h3>
                                        </div>
                                        <div className="hover__title-wrap">
                                          <h3 className="hover__title">
                                            <FormattedMessage
                                              id="comingSoon"
                                              defaultMessage="Coming soon"
                                            />
                                          </h3>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div
                                  key={v.id}
                                  className="related-slide"
                                  onClick={this.goToPlay.bind(this, {
                                    video: v,
                                  })}
                                >
                                  <div className="channels-thumb channels-thumb--genre">
                                    <div className="channels-image channels-image--genre no-radius">
                                      <img
                                        className="channels-thumb__image channels-thumb__image--genre rounded-0"
                                        src={v.preview}
                                        alt={v.name}
                                      />
                                    </div>
                                    <div className="channels-thumb__fav">
                                      <input
                                        className="icon-toggle favoriteClick"
                                        id={"vod-" + v.id}
                                        type="checkbox"
                                        checked={this.isVideoFavorite(v.id)}
                                        onChange={() => {}}
                                      />
                                      <label
                                        className="icon-toggle-label favoriteClick"
                                        htmlFor={"vod-" + v.id}
                                      >
                                        <span className="favoriteClick">
                                          <i
                                            className="fa fa-star favoriteClick"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="channels-thumb__details channels-thumb__details--related">
                                    <div className="channels-thumb__inner channels-thumb__inner--related">
                                      <div className="channels-thumb__name channels-thumb__name--related">
                                        {v.name}
                                        <span className="channel-show__name">
                                          <img
                                            className="related-live-icon"
                                            src="./img/play.svg"
                                            style={
                                              config.lang === "ar"
                                                ? { marginLeft: "10px" }
                                                : {}
                                            }
                                          />
                                          <FormattedMessage
                                            id="watchNow"
                                            defaultMessage="Watch Now"
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </Swiper>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      getVideoOrChannelRelatedData,
      addFavoriteVideo,
      showMessage,
      setHeaderTitle,
      addVideoHistory,
      addLikesVideos,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayVideo);



// WEBPACK FOOTER //
// ./src/components/Play/PlayVideo.js